import { action, computed, makeObservable, observable } from 'mobx';

import {
  Bitrix24AccountServer,
  IBitrix24Account
} from 'shared/entities/bitrix24';

export class Bitrix24AccountModel implements IBitrix24Account {
  readonly id: string;
  readonly dateCreated?: string;

  private _displayName: string;
  private _webhookSecretMasked: string | null;

  constructor({
    id,
    displayName,
    dateCreated,
    webhookSecretMasked
  }: IBitrix24Account) {
    this.id = id;
    this._displayName = displayName;
    this.dateCreated = dateCreated;
    this._webhookSecretMasked = webhookSecretMasked;

    makeObservable<
      Bitrix24AccountModel,
      '_displayName' | '_webhookSecretMasked'
    >(this, {
      _displayName: observable,
      _webhookSecretMasked: observable,
      displayName: computed,
      webhookSecretMasked: computed,
      mergeFromServer: action
    });
  }

  get webhookSecretMasked(): string | null {
    return this._webhookSecretMasked;
  }

  get displayName(): string {
    return this._displayName;
  }

  mergeFromServer(raw: Bitrix24AccountServer): void {
    this._displayName = raw.display_name;
    this._webhookSecretMasked = raw.webhook_secret_masked ?? null;
  }

  static fromJson(raw: Bitrix24AccountServer): Bitrix24AccountModel {
    return new Bitrix24AccountModel({
      id: raw._id,
      displayName: raw.display_name,
      dateCreated: raw.date_created,
      webhookSecretMasked: raw.webhook_secret_masked ?? null
    });
  }
}
